/* Native details handles touch, keyboard, and no-JavaScript expansion. */
if (!customElements.get('ecommerce-growth-faq')) {
  customElements.define('ecommerce-growth-faq', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('change', event => {
        if (!event.target.matches('.egf-variant')) return;
        const button = this.querySelector('button[type="submit"]');
        button.querySelector('.egf-cta-label').textContent = event.target.selectedOptions[0].dataset.available === 'true' ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }, { signal: this.abort.signal });
      document.addEventListener('shopify:block:select', event => {
        const question = event.target.closest('.egf-question') || event.target.querySelector('.egf-question');
        if (question && this.contains(question)) question.open = true;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
